import { geDateRangesForCk, getDatePickerDate, getPreviousMonthDate } from "../Helper/DatePicker/DateConverter";
import { decryptTheParams } from "../Helper/QueryParams/EncryptDecrypt";

const initialStartDate = {
  value: decryptTheParams()?.startDate || geDateRangesForCk()[0]
}
const initialEndDate = {
  value: decryptTheParams()?.endDate || geDateRangesForCk()[1]
}

const ChargingAnalyticsStartDate = (state = initialStartDate, action) => {
  switch (action.type) {
    case "ChargingAnalyticsStartDate":
      return {
        value: action.start,
      };
    default:
      return state;
  }
};
const ChargingAnalyticsEndDate = (state = initialEndDate, action) => {
  switch (action.type) {
    case "ChargingAnalyticsEndDate":
      return {
        value: action.end,
      };
    default:
      return state;
  }
};

export {
  ChargingAnalyticsStartDate,
  ChargingAnalyticsEndDate
}